import customer from './customer';
import details from './details';
import app from './app';
import apigee from './apigee'

export default {
    customer,
    details,
    app,
    apigee
};



// WEBPACK FOOTER //
// ./src/actions/index.js